import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { apiBaseUrl } from '../../config/runtime';
import './ClientManager.css';

const CompanyManager = () => {
  const [companies, setCompanies] = useState([]);
  const [selected, setSelected] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [form, setForm] = useState({
    name: '',
    document: '',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    notes: '',
    tags: ''
  });

  const loadCompanies = async () => {
    try {
      const res = await axios.get(`${apiBaseUrl}/companies`);
      setCompanies(res.data || []);
    } catch (error) {}
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...form,
        tags: form.tags.split(',').map((t) => t.trim()).filter(Boolean)
      };
      if (selected) {
        await axios.put(`${apiBaseUrl}/companies/${selected.id}`, payload);
      } else {
        await axios.post(`${apiBaseUrl}/companies`, payload);
      }
      setForm({ name: '', document: '', contact_name: '', contact_email: '', contact_phone: '', notes: '', tags: '' });
      setSelected(null);
      loadCompanies();
    } catch (error) {}
  };

  const handleEdit = (company) => {
    setSelected(company);
    setForm({
      name: company.name || '',
      document: company.document || '',
      contact_name: company.contact_name || '',
      contact_email: company.contact_email || '',
      contact_phone: company.contact_phone || '',
      notes: company.notes || '',
      tags: (company.tags || []).join(', ')
    });
  };

  const handleDelete = async (companyId) => {
    try {
      await axios.delete(`${apiBaseUrl}/companies/${companyId}`);
      if (selected && selected.id === companyId) {
        setSelected(null);
      }
      loadCompanies();
    } catch (error) {}
  };

  const filteredCompanies = companies.filter((company) => {
    const text = [
      company.name,
      company.document,
      company.contact_name,
      company.contact_email,
      company.contact_phone,
      ...(company.tags || [])
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return text.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="crm-manager">
      <div className="crm-manager__header">
        <h2>Cadastro de Empresas</h2>
        <p>Cadastre empresas e contatos principais.</p>
      </div>

      <div className="crm-layout">
        <div className="crm-col">
          <div className="crm-panel">
            <div className="crm-panel__header">
              <h3>{selected ? 'Editar Empresa' : 'Nova Empresa'}</h3>
              {selected && (
                <button className="ghost" type="button" onClick={() => {
                  setSelected(null);
                  setForm({
                    name: '',
                    document: '',
                    contact_name: '',
                    contact_email: '',
                    contact_phone: '',
                    notes: '',
                    tags: ''
                  });
                }}>
                  Limpar seleção
                </button>
              )}
            </div>
            <form className="crm-form" onSubmit={handleSubmit}>
              <input name="name" placeholder="Razão social" value={form.name} onChange={handleChange} required />
              <input name="document" placeholder="CNPJ" value={form.document} onChange={handleChange} />
              <input name="contact_name" placeholder="Contato principal" value={form.contact_name} onChange={handleChange} />
              <input name="contact_email" placeholder="Email do contato" value={form.contact_email} onChange={handleChange} />
              <input name="contact_phone" placeholder="Telefone do contato" value={form.contact_phone} onChange={handleChange} />
              <input name="tags" placeholder="Tags (separadas por vírgula)" value={form.tags} onChange={handleChange} />
              <textarea name="notes" placeholder="Observações" value={form.notes} onChange={handleChange} rows={3} />
              <button type="submit">{selected ? 'Atualizar Empresa' : 'Salvar Empresa'}</button>
            </form>
          </div>
        </div>

        <div className="crm-col">
          <div className="crm-panel">
            <div className="crm-panel__header">
              <h3>Empresas</h3>
              <input
                className="crm-search"
                placeholder="Buscar por nome, contato ou CNPJ"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="crm-list">
              {filteredCompanies.length === 0 && (
                <div className="crm-empty">Nenhuma empresa encontrada.</div>
              )}
              {filteredCompanies.map((company) => (
                <div key={company.id} className="crm-card">
                  <div className="crm-card__title">{company.name}</div>
                  <div className="crm-card__meta">{company.document || 'Sem documento'}</div>
                  <div className="crm-card__meta">Contato: {company.contact_name || '—'} · {company.contact_email || '—'}</div>
                  <div className="crm-card__meta">{company.contact_phone || 'Sem telefone'}</div>
                  <div className="crm-tags">
                    {(company.tags || []).map((tag) => (
                      <span key={tag} className="crm-tag">{tag}</span>
                    ))}
                  </div>
                  {company.notes && <p className="crm-card__notes">{company.notes}</p>}
                  <div className="crm-card__actions">
                    <button onClick={() => handleEdit(company)}>Editar</button>
                    <button className="ghost" onClick={() => handleDelete(company.id)}>Excluir</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyManager;
